import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";

function ProductListingImages(props) {
  const [mainImages, setMainImages] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);

  const handleMainImage = (e) => {
    const files = Array.from(e.target.files);
    setMainImages((prev) => [...prev, ...files]);
    e.target.value = ""; 
  };

  const removeMainImage = (index) => {
    setMainImages(mainImages.filter((_, i) => i !== index));
  };

  const handleGalleryImages = (e) => {
    const files = Array.from(e.target.files);
    setGalleryImages((prev) => [...prev, ...files]);
    e.target.value = ""; 
  };

  const removeImage = (index) => {
    setGalleryImages(galleryImages.filter((_, i) => i !== index));
  };

  return (
    <>
      <Row>
        <Col md={12} className="mt-4 mb-3">
          <h4>Step 5 : Product Images</h4>
        </Col>

        <Col md={12}>
          <Card className="p-4">
            
            <Row className="mb-4">
              <Col md={4} className="amazon-listing-labels">
                Main Image :
              </Col>
              <Col md={8}>
                <div className="d-flex align-items-start">
                  <Input
                    type="file"
                    multiple 
                    onChange={handleMainImage}
                    className="listing-hidden-filetext"
                  />
                  
                  <div className="listing-file-container ml-3">
                    <ul className="gallery-file-list">
                      {mainImages.length > 0 ? (
                        mainImages.map((file, index) => (
                          <li key={index} className="d-flex align-items-center mb-2">
                            <span className="listing-filename-text" title={file.name}>
                              {file.name}
                            </span>
                            <button className="btn p-0 ml-2 mr-2" onClick={() => removeMainImage(index)}>
                              <FontAwesomeIcon color="red" icon={faWindowClose} />
                            </button>
                          </li>
                        ))
                      ) : (
                        <li className="no-files-attached-text mt-1">
                          No files attached
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">
                Gallery Images :
              </Col>
              <Col md={8}>
                <div className="d-flex align-items-start">
                  <Input
                    type="file"
                    multiple
                    onChange={handleGalleryImages}
                    className="listing-hidden-filetext"
                  />
                  
                  <div className="listing-file-container ml-3">
                    <ul className="gallery-file-list">
                      {galleryImages.length > 0 ? (
                        galleryImages.map((file, index) => (
                          <li key={index} className="d-flex align-items-center mb-2">
                            <span className="listing-filename-text" title={file.name}>
                              {file.name}
                            </span>
                            <button className="btn p-0 ml-2 mr-2" onClick={() => removeImage(index)}>
                              <FontAwesomeIcon color="red" icon={faWindowClose} />
                            </button>
                          </li>
                        ))
                      ) : (
                        <li className="no-files-attached-text mt-1">
                          No files attached
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>

          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>
            ← Back
          </button>
          <button className="btn btn-primary" onClick={props.nextStep}>
            Next →
          </button>
        </Col>
      </Row>
    </>
  );
}

export default ProductListingImages;